// extracted by mini-css-extract-plugin
export default {"socialMedia":"social_socialMedia__4KOio","socialContainer":"social_socialContainer__-PWGC","payxInfo":"social_payxInfo__6D7x0"};